import { gql } from '@apollo/client';

export const GET_USER_PERMISSIONS = gql`
  query GetUserPermissions {
    user {
      email
      notificationPreferences {
        dailyPricingReportPortfolioCodes
      }
      permissions {
        pledging
        pledgeAndRelease
        muniCredit
        apm
        files
        cds
        houstonTrust
      }
      portfolios {
        institutionId
        portfolioCode
        portfolioId
        portfolioName
      }
    }
  }
`;
